// extracted by mini-css-extract-plugin
module.exports = {"swiperContainer":"Slider_swiperContainer__3_nxN","swiperWrapper":"Slider_swiperWrapper__1o0ma","swiperPagination":"Slider_swiperPagination__1CXHr"};